import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import { TrapTableType } from 'components/TrapsTables/trapTables';

export interface TrapPageState {
  slug: string;
  currentTrapTable: TrapTableType;
  totalTraps?: number;
  totalInsects?: number;
  hubsAmount?: number;
}

export const initialState: TrapPageState = {
  slug: '',
  currentTrapTable: TrapTableType.MultiCatchMouseTraps,
};

const trapPageSlice = createSlice({
  name: 'Traps',
  initialState,
  reducers: {
    setCurrentTrapTable(state, action: PayloadAction<{ traps: TrapTableType; slug: string }>) {
      state.currentTrapTable = action.payload.traps;
      state.slug = action.payload.slug;
    },
    setAdditionalInfo(state, action: PayloadAction<{ totalTraps?: number; totalInsects?: number }>) {
      state.totalTraps = action.payload.totalTraps;
      state.totalInsects = action.payload.totalInsects;
    },
    clearTablesData(state) {
      state.currentTrapTable = TrapTableType.MultiCatchMouseTraps;
      state.totalTraps = undefined;
      state.totalInsects = undefined;
    },
    setHubsAmount(state, action: PayloadAction<number>) {
      state.hubsAmount = action.payload;
      if (state.hubsAmount === 0) {
        state.currentTrapTable = TrapTableType.Hubs;
      }
    },
  },
});

export const { setCurrentTrapTable, setAdditionalInfo, clearTablesData, setHubsAmount } = trapPageSlice.actions;

export default trapPageSlice.reducer;
